import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

// The giveaway panel's first line. It takes turns between "GIVEAWAY  <status>" and the prize (cut short with … when
// it's too long). On narrow phones where the status doesn't fit beside the title, the status gets its own turn
// instead: GIVEAWAY → status → prize. `hold` keeps the status showing (while entering, or to show a problem).
export default function GiveawayTitle({ title, label, labelColor, prize, hold, titleClassName, titleStyle }) {
  const boxRef = useRef(null);
  const sizerRef = useRef(null);
  const [fits, setFits] = useState(true);
  const [turn, setTurn] = useState(0);

  // Whether the title and status fit side by side
  useLayoutEffect(() => {
    const check = () => {
      if (!boxRef.current || !sizerRef.current) return;
      setFits(sizerRef.current.getBoundingClientRect().width <= boxRef.current.getBoundingClientRect().width + 0.5);
    };
    check();
    const observer = new ResizeObserver(check);
    observer.observe(boxRef.current);
    document.fonts?.ready.then(check);
    return () => observer.disconnect();
  }, [title, label]);

  useEffect(() => {
    if (hold) return;
    const timer = setInterval(() => setTurn((t) => t + 1), 3000);
    return () => clearInterval(timer);
  }, [hold]);

  const frames = fits ? ['both', 'prize'] : ['title', 'label', 'prize'];
  const frame = hold ? (fits ? 'both' : 'label') : frames[turn % frames.length];
  const titleEl = <span className={titleClassName} style={titleStyle}>{title}</span>;
  const labelEl = <span className="font-semibold whitespace-nowrap" style={{ fontSize: '9px', lineHeight: 1, color: labelColor }}>{label}</span>;

  return (
    // flex, not a plain block: a block adds a full text line's height around the (tight) title, which made a gap
    <div ref={boxRef} className="relative w-full flex overflow-hidden text-left">
      {/* Invisible: sets the line's height, and is measured to see if the title and status fit together */}
      <span ref={sizerRef} aria-hidden="true" className="invisible flex-shrink-0 inline-flex items-center gap-1.5 whitespace-nowrap">{titleEl}{labelEl}</span>
      <div key={frame} className="giveaway-swap absolute inset-0 flex items-center gap-1.5 whitespace-nowrap min-w-0">
        {frame === 'both' && <>{titleEl}{labelEl}</>}
        {frame === 'title' && titleEl}
        {frame === 'label' && labelEl}
        {frame === 'prize' && <span className={`${titleClassName} truncate min-w-0`} style={{ ...titleStyle, textTransform: 'none', letterSpacing: 0 }}>{prize}</span>}
      </div>
    </div>
  );
}
